import { useReward } from "api/rewards";
import { SelectInput } from "components/FormControls/Select/Select";
import { useMessage } from "hooks/intl";
import { useManageInfiniteScroll } from "hooks/useManageInfiniteScroll";
import { memo, useState } from "react";
import { useStyles } from "../../styles";

interface Props {
  index: number;
  size: "small" | "medium" | "inline";
  onChange?: () => void;
}
export const RewardName = memo(({ index, size, onChange }: Props) => {
  const classes = useStyles();
  const { message } = useMessage();
  const isInlineType = size === "inline";
  const [rewardSearch, setRewardSearch] = useState("");
  const { useInfiniteRewardList } = useReward();

  const {
    data: infiniteRewardList,
    size: rewardsListSize,
    setSize: setRewardListSize,
    isValidating,
  } = useInfiniteRewardList({
    filters: rewardSearch
      ? [
          {
            condition: "like",
            query: "name",
            value: rewardSearch,
          },
        ]
      : [],
    sortKey: "name",
    order: "asc",
  });

  const { infiniteData: rewardsList, anyElementsToFetch: anyRewardsToFetch } =
    useManageInfiniteScroll(infiniteRewardList || []);

  return (
    <SelectInput
      name={`filters.${index}.value`}
      displaySearch
      data-test-id="filter-value"
      width="100%"
      items={rewardsList.map((reward) => ({
        label: reward.name,
        id: reward.name,
      }))}
      size={isInlineType ? "small" : size}
      onChange={onChange}
      asyncSearch={(searchedQuery) => setRewardSearch(searchedQuery)}
      placeholder={message({ id: "value" })}
      adjustWidthToValue={isInlineType}
      anyElementsToFetch={anyRewardsToFetch}
      loadMoreElements={() =>
        !isValidating && setRewardListSize(rewardsListSize + 1)
      }
      className={isInlineType ? classes.inlineValue : ""}
      validateOnChange
    />
  );
});
